export default __webpack_public_path__ + "static/media/vf2.5c0142d7.jpg";